import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { UserContextProvider } from "./context/userContext";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux'
import { configureStore } from '@reduxjs/toolkit';
import { CookiesProvider } from 'react-cookie';

const root = ReactDOM.createRoot(document.getElementById('root'));
const initialState = {
  userRole: null
}
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_USERROLE':
      return {
        userRole: action.text
      }
    default:
      return state
  }
}
const store = configureStore({ reducer })

root.render(
  <Provider store={store}>
    <CookiesProvider defaultSetOptions={{ path: '/' }}>
      <BrowserRouter>

        <UserContextProvider>
          <App />
        </UserContextProvider>

      </BrowserRouter>
    </CookiesProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
